import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { extractError } from '@iso/lib//helpers/api';
import { types, actions } from './reducer';
import CurrencyService from '@iso/services/SettingsService/GeneralService/CurrencyService';

function* deleteCurrency({ id }) {
    try {
        yield call(CurrencyService.deleteOne, id);
        yield put(actions.deleteCurrencySucceeded(id));
    } catch (error) {
        yield put(actions.deleteCurrencyFailed(extractError(error)));
    }
}

function* watchDeleteCurrency() {
    yield takeEvery(
        types.REQUEST_DELETE_CURRENCY,
        deleteCurrency,
    );
}

function* deleteSaga() {
    yield all([
        fork(watchDeleteCurrency),
    ]);
}

export default deleteSaga;
